import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../pages/Products';

export const FloatingCartIcon = () => {
  const { getCartItemCount } = useCart();
  const cartItemCount = getCartItemCount();
  const location = useLocation();

  // Do not show the floating icon if the cart is empty or the user is on the cart page.
  if (cartItemCount === 0 || location.pathname === '/cart') {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Link
        to="/cart"
        className="relative flex items-center justify-center rounded-full text-white shadow-lg transition-all duration-300 transform hover:scale-110"
        style={{ 
          backgroundColor: '#D62828',
          width: '64px',
          height: '64px',
          minWidth: '64px',
          minHeight: '64px'
        }}
        aria-label="View shopping cart"
      >
        <span 
          className="material-symbols-outlined text-white"
          style={{ fontSize: '32px' }}
        >
          shopping_cart
        </span>
        {cartItemCount > 0 && (
          <span
            className="absolute text-xs font-bold text-white rounded-full flex items-center justify-center shadow-md"
            style={{ 
              backgroundColor: '#185E20',
              top: '-4px',
              right: '-4px',
              width: '24px',
              height: '24px',
              minWidth: '24px',
              minHeight: '24px'
            }}
          >
            {cartItemCount}
          </span>
        )}
      </Link>
    </div>
  );
};